import { AppContext } from 'components/providers/app-config-provider'
import * as React from 'react'

export const useAppConfig = () => React.useContext(AppContext)
